export const skinsBox: any = {
	OperationPhoenix: {
		skins: [
			{
				id: 0,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAR17PLfYQJD_9W7m5a0mvLwOq7cqWdQ-sJ0xOzAot-jiQa3-hBqYzvzLdSVJlQ3NQvR-FfsxL3qh5e7vM6bzSA26Sg8pSGKJUPeNtY/360fx360f',
				fullName: 'AWP | Asiimov',
				name: 'Asiimov',
				gun: 'AWP',
				type: 'Sniper Rifle',
				rarity: 'Covert',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 1,
				image: 'assets/OperationPhoenix/aug.png',
				fullName: 'AUG | Chameleon',
				name: 'Chameleon',
				gun: 'AUG',
				type: 'Rifle',
				rarity: 'Covert',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 2,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhjxszJemkV09-5lpKKqPv9NLPFqWdQ-sJ0xL6VrNj3jlCy_0tpZj-nINOTIwRqMwzZ8lLrle6-h5K_75XJnCRruSA8pSGKEtwySt8/360fx360f',
				fullName: 'AK-47 | Redline',
				name: 'Redline',
				gun: 'AK-47',
				type: 'Rifle',
				rarity: 'Classified',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 3,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpouLWzKjhjxszGfitD0924gImagvLLP7LWnn9u5MRjjeyPpt-s2VHm-xE6ZWCnJdeTcQZvM1jV_1Dole68h8DtvZTPnXJhsnUm4WGdwUK2icMtfw/360fx360f',
				fullName: 'Nova | Antique',
				name: 'Antique',
				gun: 'Nova',
				type: 'Shotgun',
				rarity: 'Classified',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 4,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopuP1FAR17OORIQJW_tWxm460m_7zO6_ummpD78A_0--Ypoqt3Q2yrkI4Y2qnctXAJgA8NF3SqVXtkLzsjMfpvsvBmHs1uT5iuyhQpuRimA/360fx360f',
				fullName: 'P90 | Trigon',
				name: 'Trigon',
				gun: 'P90',
				type: 'SMG',
				rarity: 'Classified',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 5,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoo6m1FBRp3_bGcjhQ09-jq5WYh8jxP77Wl2VF18l4jeHVyoD0mlOx5UdtZT_1JIHGIQNoMA2C_1PslO65h5Tpvc_AwXZmuiMr5CnZmhfm0hpSLrs4U9WKdHc/360fx360f',
				fullName: 'USP-S | Guardian',
				name: 'Guardian',
				gun: 'USP-S',
				type: 'Pistol',
				rarity: 'Restricted',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 6,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7umeldf0Ob3fDxBvYyJhoWPn_jgDLfYkWNF18lwmO7Eu4igjQWx-xFoYGqmJ4WRcgQ4Z17T_1i5wb2-gZPv7s-fwXNjuCEks33D30vgwSze3sU/360fx360f',
				fullName: 'MAC-10 | Heat',
				name: 'Heat',
				gun: 'MAC-10',
				type: 'SMG',
				rarity: 'Restricted',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 7,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopb3wflFf0Ob3YjoXuY-JhJWHhPLLP7LWnn9u5MRjjeyP8dmj3A3k-xdsZj2lJNPAc1JvZlvXqQXrx-_rgcPuuZifmHFlvCgms2GdwUKNNulqdg/360fx360f',
				fullName: 'SG 553 | Pulse',
				name: 'Pulse',
				gun: 'SG 553',
				type: 'Rifle',
				rarity: 'Restricted',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 8,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposLuoKhRf0v33dzxP7c-Jh4efqPv9NLPFqWdQ-sJ0xLzArN6h2VDg-hJvMGr2dYXDIFQ8YQmFqALqw-ztgJXtuszBzCRkuHY8pSGKWiPDS9g/360fx360f',
				fullName: 'FAMAS | Sergeant',
				name: 'Sergeant',
				gun: 'FAMAS',
				type: 'Rifle',
				rarity: 'Restricted',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 9,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhjxszcdD4b08-3moSYg_jmPoTdn2xZ_Pp9i_vG8MLw2wy2-xc9MjqhJ9fEd1I2N17Z-AC7lLvvgMfouM-ayXprvygi7SyJgVXp1mC692Rx/360fx360f',
				fullName: 'Tec-9 | Sandstorm',
				name: 'Sandstorm',
				gun: 'Tec-9',
				type: 'Pistol',
				rarity: 'Mil-Spec',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 10,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpouL-iLhFfwOP3fzhF6cqJgJWZhsjgNqnDl2Jf18l4jeHVyoD0mlOx5Uo_ZTr1I47HclM4MwvZ_ljtwejnjcC_6Zyan3Fq6XEl5irdzhGz0E1SLrs4EJsmc8Q/360fx360f',
				fullName: 'Negev | Terrain',
				name: 'Terrain',
				gun: 'Negev',
				type: 'Machine-gun',
				rarity: 'Mil-Spec',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 11,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhjxszFcDoV09SzlZaOmcj4OrzZglRd6dd2j6fE9Nyl2lG1qkI6amH3cYSSelA7aAnZ-VXtkOfvhJDqvJ7BnXJluyIi-z-DyFkJt659/360fx360f',
				fullName: 'MAG-7 | Heaven Guard',
				name: 'Heaven Guard',
				gun: 'MAG-7',
				type: 'Shotgun',
				rarity: 'Mil-Spec',
				collection: 'Operation Phoenix',
				year: 2014,
			},
			{
				id: 12,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoo7e1f1Jf0Ob3ZDBS09-5hpCEhfb4DLfYkWNF18lwmO7Eu43w2gfnqUc6MjugLdDDd1BrN16E-FTvyenugpPv6ZiYnXo1uHV34yrD30vgsbpsexc/360fx360f',
				fullName: 'UMP-45 | Corporal',
				name: 'Corporal',
				gun: 'UMP-45',
				type: 'SMG',
				rarity: 'Mil-Spec',
				collection: 'Operation Phoenix',
				year: 2014,
			},
		],
	},
	OperationWildfire: {
		skins: [
			{
				id: 0,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV08-jhIWZlP_1IbzUklRd4cJ5ntbN9J7yjRrsqkM4ZmqmLILHdQY6aFvW_AC9lO2718S-ucnLwCRnvSN24nmJzEDln1gSOcGSLCO2/360fx360f',
				fullName: 'AK-47 | Fuel Injector',
				name: 'Fuel Injector',
				gun: 'AK-47',
				type: 'Rifle',
				rarity: 'Covert',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 1,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou-6kejhnwMzFJTwW08y_m46OkuXLP7LWnn9u5MRjjeyPp4j2iwC38kA9N2j7IIeSe1M9ZQrZ-VS3wefv0ZG_tZXOyHo3uSZ34WGdwUJSqpF9BQ/360fx360f',
				fullName: 'M4A4 | The Battlestar',
				name: 'The Battlestar',
				gun: 'M4A4',
				type: 'Rifle',
				rarity: 'Covert',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 2,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposr-kLAtl7PLZTjlH_9mkgIWKkPvxDLDEm2JS4Mp1mOjG-oLKhF2zowcDPzixc9OLcw82ZlyF8wC8wb251MW4tcifmydi7CEn4HiPlhyy1BxJbeNshqPIHELeWfJvK5CfiA/360fx360f',
				fullName: 'Desert Eagle | Kumicho Dragon',
				name: 'Kumicho Dragon',
				gun: 'Desert Eagle',
				type: 'Pistol',
				rarity: 'Classified',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 3,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpouLWzKjhjxszGfitD09SvhIWZlfL1IK_ummJW4NFOhujT8om7jVfi_xZtMjjxJtLGdQ5oMF7Z-AC8w-jm1J-1upvAwXZh6CkjtizbyQv3308wMAGOhw/360fx360f',
				fullName: 'Nova | Hyper Beast',
				name: 'Hyper Beast',
				gun: 'Nova',
				type: 'Shotgun',
				rarity: 'Classified',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 4,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAR17PLfYQJP7c-ikZKSqPv9NLPFqWdQ-sJ0xL-Qoomm2wHk_0A6YWzzd9LHe1I4MFyD_Vi2lO7ogMTptZjPySE37iQ8pSGKluvjCzA/360fx360f',
				fullName: 'AWP | Elite Build',
				name: 'Elite Build',
				gun: 'AWP',
				type: 'Sniper Rifle',
				rarity: 'Classified',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 5,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposbaqKAxf1OD3djFN79fnzL-KgPbmN4Tdn2xZ_Pp9i_vG8MKk0Qy3-xc_Zm_wJI-SclQ_N1uCqALswu7o1Je_vZXOzXcw6yAi4yragVXp1hC1mqlk/360fx360f',
				fullName: 'Glock-18 | Royal Legion',
				name: 'Royal Legion',
				gun: 'Glock-18',
				type: 'Pistol',
				rarity: 'Restricted',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 6,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposLuoKhRf0uL3dzxP7c-Jl4-Fg_jhIYTdn2xZ_Pp9i_vG8MKj3VDh-kY9MWr3dYDDdwZtaQnV-Fi4k-vph8e0vcmYzXBlvCNw7X7UgVXp1iHYIfHn/360fx360f',
				fullName: 'FAMAS | Valence',
				name: 'Valence',
				gun: 'FAMAS',
				type: 'Rifle',
				rarity: 'Restricted',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 7,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou6ryFBRw7P7YJgJL4cy_hoW0m_7zO6_ummpD78A_i-zEod-kile3-UJtZz-hd4_Dd1VoZV6Dq1i5wuu8jZDo6M_NzHIx6z5iuyjkfvt3Uw/360fx360f',
				fullName: 'MP7 | Impire',
				name: 'Impire',
				gun: 'MP7',
				type: 'SMG',
				rarity: 'Restricted',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 8,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhnwMzFcDoV08yklYWfmOX9MrXummJW4NFOhujT8om73QGw8kU6MT3wJIWUdw8_YAnS-Vi5lLjmgJa0tJqcwSQ36yQhtHyIzAv330_ZgbOSgA/360fx360f',
				fullName: 'MAG-7 | Praetorian',
				name: 'Praetorian',
				gun: 'MAG-7',
				type: 'Shotgun',
				rarity: 'Restricted',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 9,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposLOzLhRlxfbGTj5X09q_goWYkuHxPYTQg2xc7ctlj-3--YXygECLpxIuNDztcdSSew47ZgqD-AS6k-bv05Lp6MvPyCNj6SVz4n2LzUTiiRgabbRtheveFwsXZP-DHw/360fx360f',
				fullName: 'Five-SeveN | Triumvirate',
				name: 'Triumvirate',
				gun: 'Five-SeveN',
				type: 'Pistol',
				rarity: 'Restricted',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 10,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoo6m1FBRp3_bGcjhQ09ulq5WYh8jiPLfFl2xU18l4jeHVyoD0mlOx5UJtNm3zdoLBdlBtYVHQ_lLqxbi-gJe_6p7AyHEw6yYnsymOyUflhRlSLrs4lxDcE7E/360fx360f',
				fullName: 'USP-S | Lead Conduit',
				name: 'Lead Conduit',
				gun: 'USP-S',
				type: 'Pistol',
				rarity: 'Mil-Spec',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 11,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpotLO_JAlf0Ob3czRY49KJl4mfnu3xPYTdn2xZ_Pp9i_vG8ML22we18ko6Nm71JdDGdwQ7Yl3S-FXrxu27h8fqtZybwHAy6Scl43zagVXp1pQaPStA/360fx360f',
				fullName: 'PP-Bizon | Photic Zone',
				name: 'Photic Zone',
				gun: 'PP-Bizon',
				type: 'SMG',
				rarity: 'Mil-Spec',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 12,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopamie19f0Ob3Yi5FvISJmoWIhfjkPKjummJW4NFOhujT8om7i1DmrUBuMjjzJ4KcJ1JtMAzTqwTokLvnhcS5vJSfmndqvCJz5y3enwv330_MO8kGzA/360fx360f',
				fullName: 'SSG 08 | Necropos',
				name: 'Necropos',
				gun: 'SSG 08',
				type: 'Sniper Rifle',
				rarity: 'Mil-Spec',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 13,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpos7asPwJf0uL3dShD4N6zhoWfg_bnDLjQhH9U5Pp9g-7J4bP5iUazrl1pYTynJoKUcwBqM1CB_VO7xb_sg5Dp7ZSfzSRns3IhtiqLyRzi1ExPcKUx0nMKTIzL/360fx360f',
				fullName: 'Dual Berettas | Cartel',
				name: 'Cartel',
				gun: 'Dual Berettas',
				type: 'Pistol',
				rarity: 'Mil-Spec',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 13,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7umeldf0v73fDxBvYyJkYyOlOPmOrjYgnJu5Mx2gv3--Y3nj1H680tuY272JYPDIVM7NAqBrlm6lbjug8K6vMufy3BjuXEnsXuMnRK3gwYMMLJOLgHZlA/360fx360f',
				fullName: 'MAC-10 | Lapis Gator',
				name: 'Lapis Gator',
				gun: 'MAC-10',
				type: 'SMG',
				rarity: 'Mil-Spec',
				collection: 'Operation Wildfire',
				year: 2016,
			},
			{
				id: 14,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhnwMzcdD4b09a3mYKCjvbLP7LWnn9u5MRjjeyP8d3z3Abh-UI-MW70IIOTdlA2YQnV-1PtwufmhcO7upXIznsw7CEj5GGdwULKp4MnwA/360fx360f',
				fullName: 'Tec-9 | Jambiya',
				name: 'Jambiya',
				gun: 'Tec-9',
				type: 'Pistol',
				rarity: 'Mil-Spec',
				collection: 'Operation Wildfire',
				year: 2016,
			},
		],
	},
	WinterOffensive:{
		skins: [
			{
				id: 0,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou-6kejhjxszFJQJD_9W7m5a0mvLwOq7cqWdQ-sJ0xOvEpIj0jAbkqEE_ZD3xctLGJAE_Zw7U-QTowefth8TpvM_InHZh6XQ8pSGKWYJAoJI/360fx360f',
				fullName: 'M4A4 | Asiimov',
				name: 'Asiimov',
				gun: 'M4A4',
				type: 'Rifle',
				rarity: 'Covert',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 1,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopbuyLgNv1fX3cih9_92hkYSEkfHLPLjFmXtE5dVOhuDG_ZjKhFWmrBZyZG_ycNCQewc_NA6D_AC3x-7phMW77p7NnHZi6yJ0s3mIzBO21B1EPPsv26Kzq1aSUw/360fx360f',
				fullName: 'Sawed-Off | The Kraken',
				name: 'The Kraken',
				gun: 'Sawed-Off',
				type: 'Shotgun',
				rarity: 'Covert',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 2,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAR17PLfYQJB496klb-HnvD8J4Tdl3lW7YtyjLuR9omjiVfl-kZtMW2iJ4bBelc2ZVjY-wTtxe3ohsXu6sydzSNnpGB8shVvZCcj/360fx360f',
				fullName: 'AWP | Redline',
				name: 'Redline',
				gun: 'AWP',
				type: 'Sniper Rifle',
				rarity: 'Classified',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 3,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou-6kejhz2v_Nfz5H_uO1gb-Gw_alfqjuk2dU78R_ntbN_Iv9nGu4qgE7NnfyddXHIAY-Z1jW_lm-yO--1pO_vsmcz3ow7HQl53-PmETjiBBMa-Nrm7XAHnr9YjkW/360fx360f',
				fullName: 'M4A1-S | Guardian',
				name: 'Guardian',
				gun: 'M4A1-S',
				type: 'Rifle',
				rarity: 'Classified',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 4,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhjxszYI2gS086zkomFkvPLP7LWnn9u5MRjjeyPrIj02wy2qEZqYjv1IYGTdwM7M1nX-lHryLvuhcLo7s7My3tqvnMk4mGdwUL_7jJtRA/360fx360f',
				fullName: 'P250 | Mehndi',
				name: 'Mehndi',
				gun: 'P250',
				type: 'Pistol',
				rarity: 'Classified',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 5,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpos7asPwJf2-r3fDxQ5dK3q5OemeX9IL7ummJW4NFOhujT8om7ilewrUBtNWyicoLEd1Q3Mw2G-APswbrqhpW6u5zMmHEyuiQi4i3UnQv330-xiJ-Mhw/360fx360f',
				fullName: 'Dual Berettas | Marina',
				name: 'Marina',
				gun: 'Dual Berettas',
				type: 'Pistol',
				rarity: 'Restricted',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 6,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou6r8FAZt7OfAfi9M9eOkm5OOqPrkaoTdn2xZ_Pp9i_vG8ML02QzjrUJvZ2n3cdTEewBqNF7S-Ae6kufr0J65vJrBnyBisnQqsXiOgVXp1uZ7p0lz/360fx360f',
				fullName: 'MP9 | Rose Iron',
				name: 'Rose Iron',
				gun: 'MP9',
				type: 'SMG',
				rarity: 'Restricted',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 7,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpouLWzKjhjxszbeihO4OO4m5aKqPv9NLPFqWdQ-sJ0xLyUrYih2gDm_xI4Nzj7d9WWcQ49M1jVrlS9yea5gpO0v5qbyXU27HE8pSGK-gPmPaU/360fx360f',
				fullName: 'Nova | Rising Skull',
				name: 'Rising Skull',
				gun: 'Nova',
				type: 'Shotgun',
				rarity: 'Restricted',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 8,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposLuoKhRf0Ob3dzxP7c-JhJWHhPLLP7LWnn9u5MRjjeyP843x3VCyqBdrMWmgd9DAdAM7Ml-D-Vi-wrrvjJe9uJ3AyXZqvyl3tmGdwUKbfF5qgg/360fx360f',
				fullName: 'FAMAS | Pulse',
				name: 'Pulse',
				gun: 'FAMAS',
				type: 'Rifle',
				rarity: 'Restricted',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 9,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposbupIgthwczLZAJR7dKyh5SEhfrLP7LWnn9u5MRjjeyPpdyt0Qfj_EFrNm72dtCddgZqYwrV-1DqwrrngZ-_7ZzLm3c27iJztmGdwUKMthHedA/360fx360f',
				fullName: 'Galil AR | Sandstorm',
				name: 'Sandstorm',
				gun: 'Galil AR',
				type: 'Rifle',
				rarity: 'Mil-Spec',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 10,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpotLO_JAlf0v73ZShQ_dO_h4W0n_b4Na_emG5u5Mx2gv3--Y3nj1H6rkBoNzr3dtfHcFA_NQnW_AO-xby7h8K_78ydm3diuSMrtirVnkOz1QYMMLJJTXlsBg/360fx360f',
				fullName: 'PP-Bizon | Cobalt Halftone',
				name: 'Cobalt Halftone',
				gun: 'PP-Bizon',
				type: 'SMG',
				rarity: 'Mil-Spec',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 11,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposLOzLhRlxfbGTjVb09e3mYm0m_7zO6_ummpD78A_ieyVrN-sjlHg-hFvYzr1JYKWJAI2ZlDX8wC7xrvr05Pqvp_OnHpiuz5iuyjNWRRyUA/360fx360f',
				fullName: 'Five-SeveN | Kami',
				name: 'Kami',
				gun: 'Five-SeveN',
				type: 'Pistol',
				rarity: 'Mil-Spec',
				collection: 'Winter Offensive',
				year: 2013,
			},
			{
				id: 12,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou-jxcjhhwszHcy5L6NW3mr-HnvD8J4Tdl3lW7Yty0uiSrY-s2wHgqEE6Z2zwJdCVegY8NAmB_ljtkL_mjZG07s-fwCc3pGB8stBeF8Zo/360fx360f',
				fullName: 'M249 | Magma',
				name: 'Magma',
				gun: 'M249',
				type: 'Machine-gun',
				rarity: 'Mil-Spec',
				collection: 'Winter Offensive',
				year: 2013,
			},

		]
	},
	Spectrum2: {
		skins: [
			{
				id: 0,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV09m7hJKOhOTLP7LWnn9u5MRjjeyP89SkjAS2-0Q4MDjwLIeTcQNtaVGG_VXskrq9g8S6uMzPnSNl7ygjtmGdwUJqmcyS6w/360fx360f',
				fullName: 'AK-47 | The Empress',
				name: 'The Empress',
				gun: 'AK-47',
				type: 'Rifle',
				rarity: 'Covert',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 1,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhjxszYI2gS09-vloWZlOX7MITdn2xZ_Pp9i_vG8MKm0QKwrkI4Zmr0LYHDeg45ZAzS_lPqwLu9hpXouc_ByCYw7yJwt3eIgVXp1mgrQle0/360fx360f',
				fullName: 'P250 | See Ya Later',
				name: 'See Ya Later',
				gun: 'P250',
				type: 'Pistol',
				rarity: 'Covert',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 2,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou-6kejhz2v_Nfz5H_uOxh7-Gw_alDKjZl39F7ddOhuDG_ZjKhFWmrBZyNW2nII6SIVRoaF3WrwO_wr_qhZPutJTLzyFr7CB043yOzRaxgRwebfsv26J05txcNQ/360fx360f',
				fullName: 'M4A1-S | Leaded Glass',
				name: 'Leaded Glass',
				gun: 'M4A1-S',
				type: 'Rifle',
				rarity: 'Classified',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 3,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpotLO_JAlf0Ob3czRY49KJlYyHqP76DLfYkWNF18lwmO7Eu4im2VWx8kQ6Nm33LNSQdwZtNw3Q_AW4wOm71Me_uZrMmnVk7yhx5y7D30vgCLYcuUs/360fx360f',
				fullName: 'PP-Bizon | High Roller',
				name: 'High Roller',
				gun: 'PP-Bizon',
				type: 'SMG',
				rarity: 'Classified',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 4,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopL-zJAt21uH3di59_oSJmIyKmvb3MrXfmWVu5Mx2gv3--Y3nj1H6qhZoMDz7IIGTdlQ6aVHSq1PrkOy7hsC16p2YnyFmvSAg5inazUHkiQYMMLK1XZDX5w/360fx360f',
				fullName: 'R8 Revolver | Llama Cannon',
				name: 'Llama Cannon',
				gun: 'R8 Revolver',
				type: 'Pistol',
				rarity: 'Classified',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 5,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou6r8FAR17P7YKAJF49OJmImMn-PLP7rDkW4fu8ZwiLHE9o6m3QKxrkY6YWz3LdWUIAc6aQ7V81e_l7q5gMK178nOz2wj5HdpOStn_w/360fx360f',
				fullName: 'MP9 | Goo',
				name: 'Goo',
				gun: 'MP9',
				type: 'SMG',
				rarity: 'Restricted',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 6,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgporrf0e1Y07PLZTiVPvYznwL-RnvDzKoTQmGpD681oteXI8oTht1i1uRQ5fW7zIISTdgRsMF3Q_lLslOi6hMXutJ-dzyAxs3Ei4HnalxG3g0wZP-RxxavJ2cEbG1k/360fx360f',
				fullName: 'XM1014 | Ziggy',
				name: 'Ziggy',
				gun: 'XM1014',
				type: 'Shotgun',
				rarity: 'Restricted',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 7,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpotaDyfgZf1OD3cicVueOilYOfnvT1J4Tdn2xZ_Pp9i_vG8MLwjA22qkE6ZTqhLNDBd1M8MFqC_ALok--9jMe87szNmnpk6SkhsCzegVXp1pUpIB7Y/360fx360f',
				fullName: 'CZ75-Auto | Tacticat',
				name: 'Tacticat',
				gun: 'CZ75-Auto',
				type: 'Pistol',
				rarity: 'Restricted',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 8,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoo7e1f1Jf0Ob3ZDBSuImJjM2Zlu7LPrrSnmJf7fp9g-7J4bP5iUazrl09Z2z1J9OVcwNoNVvTrlC2xuq81pS-vJnMwSYxuCcn4S7cmkHjgRAdcKUx0m-VIRwT/360fx360f',
				fullName: 'UMP-45 | Exposure',
				name: 'Exposure',
				gun: 'UMP-45',
				type: 'SMG',
				rarity: 'Restricted',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 9,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopb3wflFf1OD3YjoXuY-JhIiKmeP7PoTdn2xZ_Pp9i_vG8MKg2VK3_0RrMGjzJoKTcwJoZw7V-FG2wbrs15G-vJ3NyXows3Qg7XfcgVXp1o9GB_Io/360fx360f',
				fullName: 'SG 553 | Phantom',
				name: 'Phantom',
				gun: 'SG 553',
				type: 'Rifle',
				rarity: 'Restricted',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 10,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposbaqKAxf0Ob3djFN79eJnY6PnvD7DLfYkWNF18lwmO7Eu9-i0AK3_BBvMTz0cIaWJ1M-ZFvQ_1Hvl-y5gse0uJ_OznphvSQgsH7D30vgXIP7Nso/360fx360f',
				fullName: 'Glock-18 | Off World',
				name: 'Off World',
				gun: 'Glock-18',
				type: 'Pistol',
				rarity: 'Mil-Spec',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 11,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot6-iFAR17PLddgJN_t24k4W0g-X9MrXWmm5u5Mx2gv3--Y3nj1H6_EpvNjvzIdPGegI_MlrW_FXsyernh5O6ucjMnXJrunMl5n6JmUDk1QYMMLIfqDFVuQ/360fx360f',
				fullName: 'AUG | Triqua',
				name: 'Triqua',
				gun: 'AUG',
				type: 'Rifle',
				rarity: 'Mil-Spec',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 12,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoor-mcjhjxszcdD4b09-klYOAkvPLPKvQmlRd4cJ5ntbN9J7yjRqw_RZlMDryd4WUdwM-NwmFqwK3kuvqhpK97sjIznIy6HYi4n3Zmkewn1gSOdsvfAHj/360fx360f',
				fullName: 'Tec-9 | Cracked Opal',
				name: 'Cracked Opal',
				gun: 'Tec-9',
				type: 'Pistol',
				rarity: 'Mil-Spec',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 13,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7umeldf0v73fDxBvYyJm4OOlvn9DLfYkWNF18lwmO7Eu96gjQGw-BdpNmv3LdOUc1BrYlrZ_VDokOm91sLvvMjMmHMwvScltyvD30vgpcKNjK8/360fx360f',
				fullName: 'MAC-10 | Oceanic',
				name: 'Oceanic',
				gun: 'MAC-10',
				type: 'SMG',
				rarity: 'Mil-Spec',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 14,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopbuyLgNv1fX3cCx9_92hkYTGmPHyDL3dmXxU-vp9g-7J4bP5iUazrl1sN2D7doadIVM2YVrTrlW3lb-8h8C7us_IySc1uHYhtivazha0gh1McKUx0kEbgF-Z/360fx360f',
				fullName: 'Sawed-Off | Morris',
				name: 'Morris',
				gun: 'Sawed-Off',
				type: 'Shotgun',
				rarity: 'Mil-Spec',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 15,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposem2LFZf1OD3dm5R642Jl4WfmvLLIb7Vg3Nu5Mx2gv3--Y3nj1H6-ks9N2iictLHcQRoMgnS-Fm5yLq80cK-vsjMznswv3F0tCqLmUTjiQYMMLIPnB6PAQ/360fx360f',
				fullName: 'G3SG1 | Hunter',
				name: 'Hunter',
				gun: 'G3SG1',
				type: 'Sniper Rifle',
				rarity: 'Mil-Spec',
				collection: 'Spectrum 2',
				year: 2017,
			},
			{
				id: 16,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopbmkOVUw7PvRTi5B7c7kxL-BgvnzP77uhWdY-NZlmOzA-LP5gVO8vywwMiukcZjBdg9oaFGBqVm7xb3u1JS56s7NzyA37yV2sXzfyRG0iUoYOuBngqOfVxzAUP3CFprW/360fx360f',
				fullName: 'SCAR-20 | Jungle Slipstream',
				name: 'Jungle Slipstream',
				gun: 'SCAR-20',
				type: 'Sniper Rifle',
				rarity: 'Mil-Spec',
				collection: 'Spectrum 2',
				year: 2017,
			},
		]
	},
	Spectrum: {
		skins: [
			{
				id: 0,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV0966m4-PhOf7Ia_ummJW4NFOhujT8om73ASy-0RqNW-hLYTAcg5vMgvT_Vm4wefthpO_v8yYwHVlsicr4C3fzQv330_79eypFA/360fx360f',
				fullName: 'AK-47 | Bloodsport',
				name: 'Bloodsport',
				gun: 'AK-47',
				type: 'Rifle',
				rarity: 'Covert',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 1,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoo6m1FBRp3_bGcjhQ09-jq5WYh-TLPbTYhFRd4cJ5ntbN9J7yjRqxr0M6Z2v3IdWUIA8-YlmD_AW6wO7shZbv6ZudnHM1u3V0t3jYmx22n1gSORPnfTIP/360fx360f',
				fullName: 'USP-S | Neo-Noir',
				name: 'Neo-Noir',
				gun: 'USP-S',
				type: 'Pistol',
				rarity: 'Covert',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 2,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou-6kejhz2v_Nfz5H_uOxh7-Gw_alDL_UlWJc6dF-mNbN_Iv9nGu4qgE7Nnf2ddCdcFM3aFrX-Qftku6-gcfov5iby3tku3Ik5njVmEDiiBBFOuM-m7XAHo-5ajpc/360fx360f',
				fullName: 'M4A1-S | Decimator',
				name: 'Decimator',
				gun: 'M4A1-S',
				type: 'Rifle',
				rarity: 'Classified',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 3,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot621FAR17PLfYQJS_8W1nI-bluP8DLfYkWNF18lwmO7Eu92kjQHgqkVrYzv0I4_AcwE7ZguDr1C2lL_tgJTou52cm3Fm6SZz4nrD30vgWTTGJEA/360fx360f',
				fullName: 'AWP | Fever Dream',
				name: 'Fever Dream',
				gun: 'AWP',
				type: 'Sniper Rifle',
				rarity: 'Classified',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 4,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpotaDyfgZf1OD3cid9_9K3n4WYqOfhIavdk1Rd4cJ5ntbN9J7yjRq1-0VpamClddSUJgE9Yl3SrAW3xu651pa_uZuay3Nm6SUiti7ayhzmn1gSOTyBM7R2/360fx360f',
				fullName: 'CZ75-Auto | Xiangliu',
				name: 'Xiangliu',
				gun: 'CZ75-Auto',
				type: 'Pistol',
				rarity: 'Classified',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 5,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoo7e1f1Jf1OD3ZDBS0920jZOYqPv9NLPFqWdQ-sJ0xLyUrN2l2g3sqkU-NmChJIGUcwM4NA7R_Vfvwu-7h5C8vJqdwHA3unY8pSGKnKFTvB4/360fx360f',
				fullName: 'UMP-45 | Scaffold',
				name: 'Scaffold',
				gun: 'UMP-45',
				type: 'SMG',
				rarity: 'Restricted',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 6,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgporrf0e1Y07PLZTiVP09CzlYa0kfbwNoTdn2xZ_Pp9i_vG8MLz3wHnqUI-ZGjzdY6VcAVrY1HZrlC3wOa81Je5vM_Ny3ZruXNz5CyJgVXp1kEBvvfY/360fx360f',
				fullName: 'XM1014 | Seasons',
				name: 'Seasons',
				gun: 'XM1014',
				type: 'Shotgun',
				rarity: 'Restricted',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 7,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou-jxcjhzw8zFI2kb09qkm4e0mOX9NLLfl2du5Mx2gv3--Y3nj1H6_EBvYjyhJ9KTdQBrMwyG8gXoxu--0cS5tM_NyiM26yYh43ndyRK_hAYMMLKZjvQcTA/360fx360f',
				fullName: 'M249 | Emerald Poison Dart',
				name: 'Emerald Poison Dart',
				gun: 'M249',
				type: 'Machine-gun',
				rarity: 'Restricted',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 8,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposbupIgthwczbYQJF7dC_mL-cluHxDLfYkWNF18lwmO7Eu9z03APi-hY-MW_1JIKXelc5ZgnW-FO2yevvgJLpvc7NzSE1uiMr4HbD30vg7rDTf40/360fx360f',
				fullName: 'Galil AR | Crimson Tsunami',
				name: 'Crimson Tsunami',
				gun: 'Galil AR',
				type: 'Rifle',
				rarity: 'Restricted',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 9,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7umeldf0vL3fDxBvYyJgIiOqPv1IK_ukmJH7fp9g-7J4bP5iUazrl04Y2nwLdedcQU2ZQmDqAS8x7jmhpW775WYwXE2siF043vcn0ew1UtFcKUx0lwt2tGi/360fx360f',
				fullName: 'MAC-10 | Last Dive',
				name: 'Last Dive',
				gun: 'MAC-10',
				type: 'SMG',
				rarity: 'Restricted',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 10,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposr-kLAtl7PDdTjlH_9mkgL-OlvD4NoTSmXlD58F0hNbN_Iv9nGu4qgE7Nnf2ctLAcFVtYAvZqFm8k-66jJ6-v5nNzCFk7HIgtyrenBHl0hpEaLQ5m7XAHlenWNbj/360fx360f',
				fullName: 'Desert Eagle | Oxide Blaze',
				name: 'Oxide Blaze',
				gun: 'Desert Eagle',
				type: 'Pistol',
				rarity: 'Mil-Spec',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 11,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopbmkOVUw7PDdTj9O-dmmhomFg8jnMLrDqWdY781lteXA54vwxg21_EI5a2j6JdWXIAQ-aVmG_wfqwubngcC5u8vAyHtlvCNw53mIyhCpwUYbyziG5kI/360fx360f',
				fullName: 'SCAR-20 | Blueprint',
				name: 'Blueprint',
				gun: 'SCAR-20',
				type: 'Sniper Rifle',
				rarity: 'Mil-Spec',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 12,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposLOzLhRlxfbGTj5X09q_goWYkuHxPYTHk2Jf18l4jeHVyoD0mlOx5UdqZzygIo-UIAVtYgvZqVm8yb--hMe06JmcyyBjvSZ2tC7ZzRLmhU5SLrs4vYCxZks/360fx360f',
				fullName: 'Five-SeveN | Capillary',
				name: 'Capillary',
				gun: 'Five-SeveN',
				type: 'Pistol',
				rarity: 'Mil-Spec',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 13,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopujwezhh3szYI2gS08-mgZSFnvzLP7LWnn9u5MRjjeyPptSi3gLh-ENlZGyiddeRcgY4NQyB_QC8xevshsfvvc_JzCNl6CZz7WGdwUITS8tjaw/360fx360f',
				fullName: 'P250 | Ripple',
				name: 'Ripple',
				gun: 'P250',
				type: 'Pistol',
				rarity: 'Mil-Spec',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 14,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopbuyLgNv1fX3cCx9_92hkYSEkfHLKbrfkm5Duvp9g-7J4bP5iUazrl1pYm2lI9WTIQA-Z1rZ_Fm9ybjqg5a-vJXOziZkvSYgtnrUm0HkhUoYcKUx0kuWxz6T/360fx360f',
				fullName: 'Sawed-Off | Zander',
				name: 'Zander',
				gun: 'Sawed-Off',
				type: 'Shotgun',
				rarity: 'Mil-Spec',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 15,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou6ryFBRw7P7YJgJW_tW0lYy0jvL4P7TGqWdY781lteXA54vwxgW3-0Y4YW73LIHDJ1Q7NVDSr1m_x-voh5e1uJ-cmHEyvCd34y2MnBapwUYbtG3eMqQ/360fx360f',
				fullName: 'MP7 | Akoben',
				name: 'Akoben',
				gun: 'MP7',
				type: 'SMG',
				rarity: 'Mil-Spec',
				collection: 'Spectrum',
				year: 2017,
			},
			{
				id: 16,
				image:
					'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpotLO_JAlf2-r3czRY49KJgI-ZmcjzIb7UmFRd4cJ5ntbN9J7yjRrlqhJsZG-mcNOTIwQ7YFmCrFe5x7i515fvuczKnCM16XEl5CzYl0Sxn1gSOcqPJmgJ/360fx360f',
				fullName: 'PP-Bizon | Jungle Slipstream',
				name: 'Jungle Slipstream',
				gun: 'PP-Bizon',
				type: 'SMG',
				rarity: 'Mil-Spec',
				collection: 'Spectrum',
				year: 2017,
			},
		]
	},
};
